var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('button',{staticClass:"add-new-action",attrs:{"name":"submit","type":"submit"},on:{"click":_vm.action}},[_c('span',[_c('b-icon',{attrs:{"scale":"3","icon":_vm.icon}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }